import '../camp_version'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import '@/plugins/gw-components'

import '@/plugins/dayjs'

import '@/plugins/filter'

import '@/assets/css/fonts.css'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
